import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { MATERIAL_UI_PROPS } from "../../../lib/data";

export const jsonRenderer = (value, name, fieldUpdateHandler, mutable) => {
    const [isValidJson, setIsValidJson] = useState(true);

    let valueToShow = "";
    if (value) {
        switch (typeof value) {
            case "object":
                valueToShow = JSON.stringify(value);
                break;
            default:
                valueToShow = value;
        }
    }

    const convertToJsonAndSend = (data) => {
        let dataToSend;
        let isJson;
        try {
            const parsedData = JSON.parse(data);
            dataToSend = parsedData;
            isJson = true;
        } catch {
            dataToSend = data;
            isJson = false;
        }
        setIsValidJson(isJson);
        fieldUpdateHandler(name, dataToSend);
    };

    return (
        <TextField
            helperText={!isValidJson && "Данные должны быть в формате JSON"}
            error={!isValidJson}
            multiline
            variant={MATERIAL_UI_PROPS.varinats.outlined}
            size={MATERIAL_UI_PROPS.sizes.small}
            disabled={!mutable}
            value={valueToShow}
            rows={3}
            onChange={(e) => convertToJsonAndSend(e.target.value)}
        ></TextField>
    );
};
